import React from "react"

const EmptyBasket = () => (
  <div>
    <p>YOUR SHOPPING BAG IS EMPTY</p>
  </div>
)

// calls to connect
export default EmptyBasket
